<template>
  <div class="">
      <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
        <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
          <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
            PLEASE MAKE A SELECTION
          </h2>
          <div class="tw-grid tw-grid-cols-2 tw-gap-10 sm:tw-flex tw-text-secondary tw-text-sm">
            <div @click="selectPath(path)" :key="path.id" v-for="path in paths" class="sm:tw-w-1/3 tw-flex tw-flex-col tw-justify-center tw-items-center tw-cursor-pointer">
              <div>
                <img class="tw-h-40 tw-w-auto" :src="path.image" />
              </div>
              <p class="tw-text-center">{{ path.title }}</p>
              <p class="tw-text-primary tw-text-center">
                {{ path.subtitle }}
              </p>
            </div>
          </div>
        </div>
        <template v-slot:footer>
          <div class="tw-mt-4">
            <button @click="goBack" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
              <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
            </button>
          </div>
        </template>
      </Modal>
  </div>

</template>

<script>
import Modal from '@/components/modals/Generic'
export default {
    name: 'DemoWizard',
    components: {
        Modal
    },
    computed: {
      paths() {
        return this.$store.state['demoWizard'].paths
      }
    },
    methods: {
      goBack() {
          this.$store.commit('demoWizard/goBack')
      },
      selectPath(path) {
        this.$store.commit('demoWizard/setPath', path)
        this.$store.commit('demoWizard/nextStep')
      }
    }
}
</script>

<style lang="scss">

</style>
